/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { IconMarker } from '@components/atoms/icons'
import ButtonLink from '@components/atoms/button-link'
import { convertToSlug } from '@utils/slugs'
import useStyles from './featured-course.styles'


const FeaturedCourse = (props) => {
  const {
    facility_name,
    facility_id,
    city,
    state,
    eyebrow,
    background,
  } = props
  const styles = useStyles({ background })

  return (
    <Box
      height={[320, 320, 'auto']}
      pt={21}
      pb={[0, 0, 10]}
      bgcolor="grey.600"
      className={styles.root}
      mb={[30, 30, 0]}
      data-testid="featured-course-root"
    >
      <Container>
        <Box bgcolor="background.paper" maxWidth={392} p={[3, 3, 4]} mt={[12, 12, 0]} mx={['auto', 'auto', 0]}>
          <Typography variant="overline" gutterBottom>{eyebrow || 'Featured Course'}</Typography>
          <Typography variant="h4" gutterBottom>{facility_name}</Typography>
          <div className={styles.location}><IconMarker /> {city}, {state}</div>
          <Box mt={4}>
            <Button
              component={ButtonLink}
              variant="outlined"
              color="secondary"
              fullWidth
              href={`/play/${state || '-'}/${convertToSlug(city)}/${convertToSlug(facility_name)}/${facility_id}`}
              dataAttrs={{
                'data-gtm-facility': facility_name,
              }}
            >
              View Course
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

FeaturedCourse.propTypes = {
  eyebrow: PropTypes.string,
  facility_name: PropTypes.string,
  facility_id: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  background: PropTypes.shape({
    url: PropTypes.string,
  }),
}

export default FeaturedCourse
